export default __webpack_public_path__ + "public/icons/permissions.png?742243cdb93bad383bdb3d6e2c5ba83f";